module.exports = __webpack_public_path__ + "img/logo.cb3cec29.svg";